import { PathMap, TStepPaths } from './registration.types';
import landingBg from '@assets/jpg/signup-bgs/step-1.jpeg';
import regFormBg from '@assets/jpg/signup-bgs/step-2.jpeg';
import roleBg from '@assets/jpg/signup-bgs/step-3.jpeg';
import successBg from '@assets/jpg/signup-bgs/step-4.jpeg';
import patientOnlyBg from '@assets/jpg/signup-bgs/step-5.jpeg';

export function mapStepPathToId(path?: TStepPaths) {
  return PathMap[path ?? 'landing'];
}

export const STEP_BG = [landingBg, regFormBg, regFormBg, roleBg, successBg, patientOnlyBg];
